import { create } from "zustand";

type EnterpriseStoreState = {
  closeAskReli: () => void;
  isMaturityHelpOpen: boolean;
  hasAskReliOpened: boolean;
  isAskReliExpanded: boolean;
  isAskReliOpen: boolean;
  openAskReli: () => void;
  setMaturityHelpOpen: (open: boolean) => void;
  toggleAskReliExpanded: () => void;
  externalCustomerId: string | null;
  setExternalCustomerId: (id: string | null) => void;
};

export const useEnterpriseStore = create<EnterpriseStoreState>((set) => ({
  closeAskReli: () => set({ isAskReliOpen: false }),
  hasAskReliOpened: false,
  isAskReliExpanded: false,
  isAskReliOpen: false,
  isMaturityHelpOpen: false,
  openAskReli: () => set({ hasAskReliOpened: true, isAskReliOpen: true }),
  setMaturityHelpOpen: (open) => set({ isMaturityHelpOpen: open }),
  toggleAskReliExpanded: () =>
    set((state) => ({ isAskReliExpanded: !state.isAskReliExpanded })),
  externalCustomerId: null,
  setExternalCustomerId: (id) => set({ externalCustomerId: id }),
}));
